<template>
  <span class="fl" v-if="hasPermission">
    <slot></slot>
    </span>
</template>
<script>
  export default {
     name: 'Permission',
    props: {
      code: {
        type: [Array,String],
        default:()=>{
          return [];
        }
      }

    },
    data() {
      return {
        hasPermission: true,
        resCode:[]
      }
    },

    updated() {
      let code = this.code;
      if(code){
        if(typeof code=='string'){
          this.resCode = code.split(',');
        }else{
          this.resCode = code;
        }
        this.hasPermission = this.check();
      }else{
        this.hasPermission = true;
      }
    },
    methods: {
      check (){
        //有权限控制的处理逻辑
        var codes = this.resCode;
        var userInfo = this.$store.state.sharing.userInfo;
        if (!userInfo) {
          userInfo = localStorage.getItem("login");
          userInfo = userInfo ? JSON.parse(userInfo) : {}
        }
        console.log("阿萨");
        var userType = userInfo.userType;
        var hasPermission = userType==1 || false; //运营端有权限
        if(!hasPermission){ //非运营端
          for(var i=0;i<codes.length;i++){
            var code = codes[i];
            // console.log(code, code.charAt(0) == userType, "阿萨斯")
            if(code.charAt(0)==userType){ //判断是否运营端，1运营、2承运、3托运
              hasPermission = true;
              break;
            }
          }
        }
        if(!hasPermission){
          return false;
        }

        var btns = userInfo.attrs.btns || [];
        var isAdmin = userInfo.attrs.isAdmin && userType == 1 || false;
        var hasPermission = isAdmin || codes.length==0;
        if (!hasPermission) {
          for (var i = 0; i < btns.length; i++) {
            for(var j=0;j<codes.length;j++){
              var code = codes[j];
              if (code == btns[i]) {
                hasPermission = true;
                break;
              }
            }
          }
        }
        return hasPermission;
      }
    },
  };
</script>
<style scoped>
.fl{
  float: left;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/permission.vue